export default __webpack_public_path__ + "static/media/Brandon_reg.cac94907.otf";